import DataService from '@/services/StrapiService';
import Constants from '@/utils/constants'

async function findVenueWineByName(vineFromSheet, identifierKeys, price) {

    const identifierToSearchObject = Constants.IDENTIFIER_TO_SEARCH;
    
    var strapiIdentiferKeys = identifierKeys.map((key) => {
      return identifierToSearchObject[key];
    });
   
    if (strapiIdentiferKeys.indexOf('purchasePriceAvg') > -1) {
      // remove purchasePriceAvg from search keys, because it is not searchable
      strapiIdentiferKeys = strapiIdentiferKeys.filter((key) => key !== 'purchasePriceAvg');
    }
    // TODO: do some logic here to use only relevant identifiers

    if (strapiIdentiferKeys.indexOf('comments') === -1 && strapiIdentiferKeys.indexOf('articleNumber') != -1) {
      // add commments to search keys if articleNumber is used
      strapiIdentiferKeys.push('comments');
    }

    // remove empty keys
    strapiIdentiferKeys = strapiIdentiferKeys.filter((key) => key != null && key != '' && key != undefined);

    var searchResult = await DataService.searchVenueWines(vineFromSheet, strapiIdentiferKeys, price);
  
    if (searchResult == null || searchResult.data == null || searchResult.data.length == 0) {
      console.log('No matching venue wine found for ' + vineFromSheet);
      return null;
    }
    var venueWine = searchResult.data[0];

    return venueWine;
}
async function findWineryByName(wineryName) {
  var searchResult = await DataService.searchWineries(wineryName);
 
  if (searchResult == null || searchResult.data.length == 0) {
    console.log('No matching winery found for ' + wineryName);
    return null;
  }
  var winery = searchResult.data[0];

  return winery;
}

async function findGrapeVarietyByName(grapeVarietyName) {
  var searchResult = await DataService.searchGrapeVarieties(grapeVarietyName);
  if (searchResult == null || searchResult.data.length == 0) {
    console.log('No matching grape variety found for ' + grapeVarietyName);
    return null;
  }
  var grapeVariety = searchResult.data[0];

  return grapeVariety;
}

async function findRegionByName(regionName) {
 
  let response = await DataService.findRegion(regionName);

  if (response["data"].data != null && response["data"].data.length > 0) {
    
    var regionFromStrapi = response["data"].data[0];
    return regionFromStrapi;
  }
  console.log('No matching region found for ' + regionName);

  return null;
}

async function findCountryByName(countryName) {
  var searchResult = await DataService.findLand(countryName);
  if (searchResult["data"].data != null && searchResult["data"].data.length > 0) {
  
    var countryFromStrapi = searchResult["data"].data[0];
    return countryFromStrapi;
  }
  console.log('No matching country found for ' + countryName);
  return null;
}

async function findWineTypeByName(wineTypeName) {
  var searchResult = await DataService.findWineType(wineTypeName);
  if (searchResult["data"].data != null && searchResult["data"].data.length > 0) {
    var wineTypeFromStrapi = searchResult["data"].data[0];
    return wineTypeFromStrapi;
  }
  console.log('No matching wine type found for ' + wineTypeName);
  return null;
}

async function findCategoryByName(categoryName) {
  var searchResult = await DataService.findCategory(categoryName);
  if (searchResult["data"].data != null && searchResult["data"].data.length > 0) {
    var categoryFromStrapi = searchResult["data"].data[0];
    return categoryFromStrapi;
  }
  console.log('No matching category found for ' + categoryName);
  return null; 
}

async function findBottleSizeByName(bottleSizeName) {
  var searchResult = await DataService.findBottleSizes(bottleSizeName);
  if (searchResult["data"].data != null && searchResult["data"].data.length > 0) {
    var bottleSizeFromStrapi = searchResult["data"].data[0];
    return bottleSizeFromStrapi;
  }
  console.log('No matching bottle size found for ' + bottleSizeName);
  return null;
}

function similarityBetween(s1, s2) {
  var longer = s1;
  var shorter = s2;
  if (s1.length < s2.length) {
    longer = s2;
    shorter = s1;
  }
  var longerLength = longer.length;
  if (longerLength == 0) {
    return 1.0;
  }
  return (longerLength - editDistance(longer, shorter)) / parseFloat(longerLength);
}

function editDistance(s1, s2) {
  s1 = s1.toLowerCase();
  s2 = s2.toLowerCase();

  var costs = new Array();
  for (var i = 0; i <= s1.length; i++) {
    var lastValue = i;
    for (var j = 0; j <= s2.length; j++) {
      if (i == 0)
        costs[j] = j;
      else {
        if (j > 0) {
          var newValue = costs[j - 1];
          if (s1.charAt(i - 1) != s2.charAt(j - 1))
            newValue = Math.min(Math.min(newValue, lastValue),
              costs[j]) + 1;
          costs[j - 1] = lastValue;
          lastValue = newValue;
        }
      }
    }
    if (i > 0)
      costs[s2.length] = lastValue;
  }
  return costs[s2.length];
}


export {
  findVenueWineByName,
  findWineryByName,
  findGrapeVarietyByName,
  findRegionByName,
  findCountryByName,
  findWineTypeByName,
  findCategoryByName,
  findBottleSizeByName,
  similarityBetween
}